import { useRouterState } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { parseOnboardingStep } from '../data/club-onboarding.ts'
import { useIsFlow } from '../navigation/use-is-flow.ts'

// Its own chunk: the bar reaches the pages of the voci through the routes, which import the root
// that mounts this slot, and a page opened from the menu never downloads it.
const ClubOnboardingBar = lazy(() =>
  import('./club-onboarding-bar.tsx').then((m) => ({ default: m.ClubOnboardingBar })),
)

/** The bar of i primi passi, at the foot of a page a voce of the guide opened: the parameter the
 *  guide's links carry is what puts it there. A flow has its own bar at the foot, and carries the
 *  parameter on without drawing this one. */
export function ClubOnboardingBarSlot() {
  const stepKey = useRouterState({
    select: (state) => parseOnboardingStep(state.location.search.onboarding),
  })
  const flow = useIsFlow()
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  if (stepKey === undefined || flow) return null
  // Mounted anew on each page, so the page «Avanti» leads to reads the voci again.
  return (
    <Suspense fallback={null}>
      <ClubOnboardingBar key={pathname} stepKey={stepKey} />
    </Suspense>
  )
}
